import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SnapshotRoutingModule } from './snapshot-routing.module';
import { CommonModule } from '@angular/common';

import { MatTooltipModule } from '@lenovo/material/tooltip';
import { MatMenuModule } from '@lenovo/material/menu';
import { MatExpansionModule } from '@lenovo/material/expansion';

import { PageSnapshotComponent } from './pages/page-snapshot.component';
import { SnapshotHeaderComponent } from './components/header/snapshot-header.component';
import { SnapshotMainComponent } from './components/main/snapshot-main.component';
import { WidgetSnapshotComponent } from './components/widgets/widget-snapshot/widget-snapshot.component';
import { ModalSnapshotComponent } from './components/modal/modal-snapshot/modal-snapshot.component';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { SharedModule } from '../shared.module';
import { PageLayoutModule } from 'src/app/components/page-layout/page-layout.module';
import { ContainerCardModule } from 'src/app/components/container-card/container-card.module';
import { CommonUiModule } from '../common/common-ui.module';
import { UiSnapshotItemListComponent } from './components/dashboard/ui-snapshot-item-list/ui-snapshot-item-list.component';
import { UiSnapshotListInfoComponent } from './components/dashboard/ui-snapshot-list-info/ui-snapshot-list-info.component';
import { UiSnapshotItemComponent } from './components/dashboard/ui-snapshot-item/ui-snapshot-item.component';
import { ModalExportLogComponent } from './components/modal/modal-export-log/modal-export-log.component';

@NgModule({
	declarations: [
		PageSnapshotComponent,
		SnapshotHeaderComponent,
		SnapshotMainComponent,
		ModalExportLogComponent,
		WidgetSnapshotComponent,
		ModalSnapshotComponent,
		UiSnapshotItemComponent,
		UiSnapshotItemListComponent,
		UiSnapshotListInfoComponent,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	exports: [WidgetSnapshotComponent],
	imports: [
		CommonModule,
		CommonUiModule,
		FontAwesomeModule,
		SnapshotRoutingModule,
		SharedModule,
		PageLayoutModule,
		ContainerCardModule,
		MatTooltipModule,
		MatMenuModule,
		MatExpansionModule,
	],
})
export class SnapshotModule {
	constructor(library: FaIconLibrary) {
		library.addIcons(faChevronUp);
		library.addIcons(faChevronDown);
	}
}
